import { render, staticRenderFns } from "./AccountStatusSettings.vue?vue&type=template&id=f629fdf8"
import script from "./AccountStatusSettings.vue?vue&type=script&lang=ts"
export * from "./AccountStatusSettings.vue?vue&type=script&lang=ts"
import style0 from "./AccountStatusSettings.vue?vue&type=style&index=0&id=f629fdf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports